import { format } from 'date-fns';
import { getDateFromApiDate } from '@general/dates';

// 'YYYY-MM-DD'
const articleDisplayDate = articleDate => {
    if (!articleDate) return null;
    const date = getDateFromApiDate(articleDate);
    return format(date, 'MMMM d, y');
};

export const mapSearchArticleToProps = ({ hit, isFavorite, onClick }) => {
    if (!hit) return;
    const id = parseInt(hit.objectID.split('-')[1], 10);
    return {
        id,
        title: hit.title,
        url: `${window.location.protocol}//${window.location.hostname}${hit.url}`,
        photoURL: hit.photo_url,
        taxonomyArticlesType: hit.article_types,
        createdAt: hit.created_at,
        displayDate: articleDisplayDate(hit.created_at),
        isFavorite,
        onClick,
    };
};

// graphQL
export const mapGraphArticleToProps = article => ({
    id: article.recordId,
    title: article.title,
    url: `${window.location.protocol}//${window.location.hostname}${article.url}`,
    // not in graphql yet
    // photoURL: article.photo_url,
    taxonomyArticlesType: article.types,
    createdAt: article.publishedAt,
    displayDate: articleDisplayDate(article.publishedAt),
    isFavorite: true,
});
